module.exports = __webpack_public_path__ + "static/media/rooney-mara.6d5f96fa.jpg";